export const TYPOGRAPHY_FONT_FAMILY_NAMES = Object.freeze({
  pretendard: 'Pretendard, Arial, sans-serif',
  elice: 'EliceDXNeolli',
  roboto: 'Roboto, Arial, sans-serif',
});

export type TypographyFontFamilyType =
  keyof typeof TYPOGRAPHY_FONT_FAMILY_NAMES;
